import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth, db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

const ProtectedRoute = ({ children }) => {
  const [allowed, setAllowed] = useState(null); // null = loading, true/false = result

  useEffect(() => {
    const checkAccess = async () => {
      const user = auth.currentUser;
      if (!user || user.email !== "brian@nieckarz.ca") return setAllowed(false);

      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists() && userDoc.data().admin === true) {
        setAllowed(true);
      } else {
        setAllowed(false);
      }
    };

    checkAccess();
  }, []);

  if (allowed === null) return <div className="p-8 text-center">Checking access...</div>;

  return allowed ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
